const normalize = (str: string) =>
  str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

export const filteredRoutes = (searchValue: string, route: any): boolean => {
  if (searchValue.length === 0) return true;

  const normalizedSearch = normalize(searchValue);

  return (
    normalize(route.name).includes(normalizedSearch) ||
    normalize(route.origin).includes(normalizedSearch) ||
    normalize(route.destination).includes(normalizedSearch) ||
    normalize(route.stops).includes(normalizedSearch)
  );
};

